import { createElement } from 'src/app/core/helpers/dom';
import { getFontFamily } from 'src/app/project/modules/white-label/white-label-utils/get-font-family';
import { addCommonStyles } from './dashboard-export.utils';

export function createAccountElement(accountName, workspaceName, scale) {
  const accountElement = createElement('div');

  accountElement.style.fontSize = `${56 * scale}px`;
  accountElement.style.lineHeight = `${70 * scale}px`;
  accountElement.style.top = `${48 * scale}px`;
  accountElement.style.whiteSpace = 'nowrap';
  accountElement.style.maxWidth = `${640 * scale}px`;
  accountElement.style.overflow = 'hidden';
  accountElement.style.textOverflow = 'ellipsis';
  accountElement.style.fontFamily = getFontFamily();

  addCommonStyles(accountElement);

  accountElement.append(accountName, createElement('br'), workspaceName);

  return accountElement;
}
